import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.tagsList.length
    ? _c(VApp, { attrs: { "data-reviews-tags": "" } }, [
        _c(
          "div",
          {
            staticClass: "text-body-1 text--text mb-2",
            class: { "ml-2": _setup.isMobile },
            attrs: { "data-qa": "reviews_tags_title" },
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _setup.t("Пациенты упоминали в отзывах", {
                    ns: _setup.language,
                  })
                ) +
                "\n  "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: { "px-2 pb-2 overflow-x-auto": _setup.isMobile } },
          [
            _c(_setup.ReviewsTagsList, {
              attrs: { "tags-list": _setup.tagsList },
              on: { "change:tag": _setup.handleChangeTag },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }